import Box from "@mui/material/Box";
import {useEffect, useRef, useState} from "react";

import IconButton from "Components/IconButton.js";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const RaildaysScrollTopButton = ({threshold = 0, placement = "listTop"}) => {
	const [visible, setVisible] = useState(false);
	const wrapperRef = useRef(null);

	useEffect(() => {
		let rafId = 0;

		const getStickyTopPx = () => {
			const rootValue = getComputedStyle(document.documentElement)
				.getPropertyValue("--raildays-content-top")
				.trim();
			const bodyValue = getComputedStyle(document.body)
				.getPropertyValue("--raildays-content-top")
				.trim();
			const parsedRoot = Number.parseFloat(rootValue);
			const parsedBody = Number.parseFloat(bodyValue);
			const base = !Number.isNaN(parsedRoot) ? parsedRoot : (!Number.isNaN(parsedBody) ? parsedBody : 96);
			return base + 12;
		};

		const updateVisibility = () => {
			const scrollY = window.scrollY || 0;
			const stickyTop = getStickyTopPx();
			const listTopInViewport = wrapperRef.current?.getBoundingClientRect?.().top ?? Number.POSITIVE_INFINITY;
			const listTopInDocument = listTopInViewport + scrollY;
			const lockPoint = listTopInDocument - stickyTop;
			const minimumScroll = Math.max(threshold, lockPoint);
			setVisible(scrollY > minimumScroll);
		};

		const handleScroll = () => {
			if (rafId) return;
			rafId = window.requestAnimationFrame(() => {
				rafId = 0;
				updateVisibility();
			});
		};

		window.addEventListener("scroll", handleScroll, {passive: true});
		window.addEventListener("resize", handleScroll, {passive: true});
		handleScroll();

		return () => {
			window.removeEventListener("scroll", handleScroll);
			window.removeEventListener("resize", handleScroll);
			if (rafId) window.cancelAnimationFrame(rafId);
		};
	}, [threshold]);

	if (placement === "fixedBottomRight") {
		if (!visible) return null;
		return (
			<Box
				sx={{
					position: "fixed",
					right: {xs: 16, md: 24},
					bottom: {xs: 16, md: 24},
					zIndex: 1200
				}}
			>
				<IconButton
					defaultStyling={true}
					label="Scroll to top"
					onClick={() => window.scrollTo({top: 0, behavior: "smooth"})}
					icon={<KeyboardArrowUpIcon />}
					style={{
						width: 48,
						height: 48,
						borderRadius: "50%",
						background: "#ffffff",
						border: "2px solid #d1d5db",
						color: "#0f172a",
						boxShadow: "0 12px 24px rgba(15, 23, 42, 0.18)"
					}}
				/>
			</Box>
		);
	}

	return (
		<Box
			ref={wrapperRef}
			sx={{
				position: "sticky",
				top: "calc(var(--raildays-content-top) + 12px)",
				zIndex: 5,
				display: "flex",
				justifyContent: "center",
				height: 0,
				overflow: "visible",
				pointerEvents: "none"
			}}
		>
			<Box sx={{pointerEvents: "auto"}}>
				<IconButton
					defaultStyling={true}
					label="Scroll to top"
					disabled={!visible}
					onClick={() => window.scrollTo({top: 0, behavior: "smooth"})}
					icon={<KeyboardArrowUpIcon />}
					style={{
						width: 48,
						height: 48,
						borderRadius: "50%",
						background: "#ffffff",
						border: "2px solid #d1d5db",
						color: "#0f172a",
						boxShadow: "0 12px 24px rgba(15, 23, 42, 0.18)",
						opacity: visible ? 1 : 0,
						transform: visible ? "translateY(0)" : "translateY(-8px)",
						transition: "opacity 180ms ease, transform 180ms ease"
					}}
				/>
			</Box>
		</Box>
	);
};

export default RaildaysScrollTopButton;
